import { Component, Input, OnInit } from '@angular/core';
import { iframeEntryUrl } from '../../../_utils/iframe-url';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
	@Input() partnerLabel: string;
	@Input() hideLoginOnMobile = false;
	showPopup = false;
	iframeURL = iframeEntryUrl();
	messageListener:any;
	iFrameCustomWidth:boolean=false;
	constructor() {}

	ngOnInit(): void {
		this.messageListener =(event:MessageEvent)=>{
           if(event.data.type=='ROUTE_CHANGE'){
			this.adjustIframeWidth(event.data.route)
		   }
		}
		window.addEventListener('message',this.messageListener,false)
	}
	
	adjustIframeWidth(currentRouteOftheIFrame:string){
		console.log("adjustIframeWidth",currentRouteOftheIFrame);
		
		if( currentRouteOftheIFrame.includes('/show-tickets-detail') ){
            this.iFrameCustomWidth=true;
		}else{
		    this.iFrameCustomWidth=false;
		}
	}
	openArtist(id) {
		if (id === null) {
			this.iframeURL = iframeEntryUrl();
		} else {
			this.iframeURL = iframeEntryUrl('/artist/detail/' + id);
		}
		this.showPopup = true;
	}

	getDynamicClass(): any {
		return {
			'custom-phone-device ios': true,
		};
	}

	openPage(page) {
		switch (page) {
			case 'artist':
				this.iframeURL = iframeEntryUrl('/tabs/explore?tab=artist');
				break;
			case 'industry':
				this.iframeURL = iframeEntryUrl('/tabs/explore?tab=industry');
				break;
			case 'shows':
				this.iframeURL = iframeEntryUrl('/tabs/shows');
				break;
			case 'gigs':
				this.iframeURL = iframeEntryUrl('/tabs/gigs');
				break;
			case 'fans':
				this.iframeURL = iframeEntryUrl();
				break;
			case 'faq':
				this.iframeURL = iframeEntryUrl('/faqs');
				break;
			case 'terms':
				this.iframeURL = iframeEntryUrl('/terms');
				break;
			case 'conduct':
				this.iframeURL = iframeEntryUrl('/rules');
				break;
			case 'privacy':
				this.iframeURL = iframeEntryUrl('/privacy');
				break;
			default:
				break;
		}
		this.showPopup = true;
	}
}
